import { displayAnswer } from "./bookingWorkspacePresentation";

const hasAnswer = value => Array.isArray(value) ? value.some(hasAnswer)
  : typeof value === "string" ? Boolean(value.trim()) : value !== null && value !== undefined;

function ResponseFields({ fields }) {
  return <dl className="grid grid-cols-2 gap-x-6 gap-y-4">{fields.map((field, index) => {
    const value = field?.displayValue;
    const text = displayAnswer(value);
    const fullWidth = fields.length === 1 || text.length > 64 || text.includes("\n") || (Array.isArray(value) && value.length > 3);
    return <div key={field?.fieldDefinitionId || `${field?.key || "answer"}-${index}`} className={`min-w-0 ${fullWidth ? "col-span-2" : ""}`}>
      <dt className="text-xs text-slate-600">{typeof field?.label === "string" ? field.label : "Answer"}</dt>
      <dd className="mt-1 whitespace-pre-wrap break-words text-sm font-medium leading-relaxed text-slate-800">{Array.isArray(value) && value.length
        ? <ul className="flex flex-wrap gap-x-4 gap-y-1">{value.map((item, itemIndex) => <li key={itemIndex}>{displayAnswer(item)}</li>)}</ul>
        : text}</dd>
    </div>;
  })}</dl>;
}

export default function BookingFormResponses({ fields }) {
  const answered = fields.filter(field => hasAnswer(field?.displayValue));
  const unanswered = fields.filter(field => !hasAnswer(field?.displayValue));
  return <>
    {answered.length ? <ResponseFields fields={answered}/> : <p className="text-sm text-slate-600">No details were provided.</p>}
    {unanswered.length > 0 && <details className="mt-4 text-slate-600">
      <summary className="w-fit cursor-pointer rounded text-xs font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-600">Show unanswered fields ({unanswered.length})</summary>
      <div className="mt-3"><ResponseFields fields={unanswered}/></div>
    </details>}
  </>;
}
